import {
  NovaSolidRemoveAddAddCircle1 as AddIcon,
  NovaCompositionCoorpacademyAnalytics as AnalyticsIcon,
  NovaSolidContentEditionBin as BinIcon,
  NovaCompositionCoorpacademyBulletPoint as BulletPointIcon,
  NovaCompositionNavigationArrowLeft as ChevronLeftIcon,
  NovaCompositionNavigationArrowRight as ChevronRightIcon,
  NovaSolidStatusClose as CloseIcon,
  NovaSolidContentEditionPencilWrite as EditIcon,
  NovaCompositionCoorpacademyEye as EyeIcon,
  NovaSolidContentContentViewModule1 as ListIcon,
  NovaSolidLoginLogout1 as LogoutIcon,
  NovaSolidApplicationsWindowUpload3 as PublishIcon,
  NovaSolidComputersSdCard as SaveIcon,
  NovaLineLoginKey1 as KlfIcon,
  NovaSolidFilesFoldersFolders as FoldersIcon,
  NovaSolidFilesBasicFileUpload2 as UploadIcon,
  NovaCompositionNavigationArrowDown as ArrowDown,
  NovaCompositionNavigationArrowLeft as ArrowLeft,
  NovaLineFilesOfficeFileOfficePdf as PDF,
  NovaSolidContentEditionDelete1 as DeleteIcon
} from '@coorpacademy/nova-icons';
import Loader from '../atom/loader';

export const ICONS = {
  add: AddIcon,
  analytics: AnalyticsIcon,
  bin: BinIcon,
  'bullet-point': BulletPointIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  close: CloseIcon,
  edit: EditIcon,
  key: KlfIcon,
  list: ListIcon,
  logout: LogoutIcon,
  publish: PublishIcon,
  save: SaveIcon,
  see: EyeIcon,
  folders: FoldersIcon,
  upload: UploadIcon,
  down: ArrowDown,
  pdf: PDF,
  back: ArrowLeft,
  delete: DeleteIcon,
  loader: Loader
};
